import {Injectable, Optional} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ConfigService} from '@ngmedax/config';
import {LoginService} from '@ngmedax/login';
import {AuthUriService} from './auth-uri.service';
import {configKeys} from '../ums.config-keys';

export interface MfaInitiateOptions {
  type?: 'totp';
  issuer?: string;
  username?: string;
}

export interface MfaInitiateResponse {
  method: 'totp';
  secretBase32: string;
  otpauthUrl: string;
  issuer: string;
  username: string;
  algorithm: string;
  digits: number;
  period: number;
}

@Injectable()
export class TwoFaService {

  public constructor(
    private http: HttpClient,
    private authUriService: AuthUriService,
    private configService: ConfigService,
    @Optional() private loginService: LoginService,
  ) {}

  public initiateSetup(userId: number, opts: MfaInitiateOptions = {}): Promise<MfaInitiateResponse> {
    const url = this.getUserApiUrl(`/${userId}/mfa/setup/initiate`);
    const body = { type: 'totp', issuer: 'myMedax', ...opts };
    return new Promise((resolve, reject) => {
      this.http.post(url, body, {headers: this.authUriService.getAuthHeaders()})
        .subscribe((resp: any) => resolve(resp as MfaInitiateResponse), error => reject(error));
    });
  }

  public verifySetup(userId: number, code: string): Promise<boolean> {
    const url = this.getUserApiUrl(`/${userId}/mfa/setup/verify`);
    return new Promise((resolve, reject) => {
      this.http.post(url, {code}, {headers: this.authUriService.getAuthHeaders()})
        .subscribe((resp: any) => resolve(!!(resp && resp.success)), error => reject(error));
    });
  }

  public disable(userId: number, code?: string, recoveryCode?: string, reason?: string): Promise<boolean> {
    const url = this.getUserApiUrl(`/${userId}/mfa`);
    const body: any = {};
    code && (body.code = code);
    recoveryCode && (body.recoveryCode = recoveryCode);
    reason && (body.reason = reason);
    return new Promise((resolve, reject) => {
      this.http.request('DELETE', url, {body, headers: this.authUriService.getAuthHeaders()})
        .subscribe((resp: any) => resolve(!!(resp && resp.success)), error => reject(error));
    });
  }

  private getUserApiUrl(suffix: string = null): string {
    return this.getUrl(configKeys.USER_URI_CONFIG_KEY, suffix);
  }

  private getUrl(configKey: string, suffix = null) {
    const baseConfigKey = configKeys.BASE_URI_CONFIG_KEY;

    let baseUri = this.configService.get(baseConfigKey)
      + this.configService.get(configKey);

    if (suffix) {
      baseUri = `${baseUri}${suffix}`;
    }

    return baseUri;
  }
}


